module.exports = __webpack_public_path__ + "static/pubsub2-f8fdf299a3d09acbaa5054eb737aa338.png";